import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  focusInput(event) {
    if (!event.detail.success) return
    if (!this.hasInputTarget) return

    this.inputTarget.focus()
  }
}
